
import { FaFileAlt, FaMobileAlt, FaPlug, FaChartBar, FaCogs, FaTools } from 'react-icons/fa';
import bgmitraicon from '../img/home-icon.jpg';

const services = [
    {
        title: 'BG Mitra',
        icon: <img src={bgmitraicon} style={{ height: 48, width: 48, borderRadius: 8, border: '2px solid #009688', background: '#e0f2f1', padding: 2 }} alt="BG Mitra" />, // styled image
        desc: 'BG Mitra is a mobile app designed for Self Help Groups (SHGs), empowering members with digital tools, resources, and support for better collaboration.',
        pricing: {
            monthly: 100,
            yearly: 1000,/* 
      details: 'This pricing is for Agents who can onboard Self Help Groups (SHGs) to BG Mitra. Agents get full access to the BG Mitra mobile app and can help SHGs benefit from digital tools and resources. Agents can also provide training and onboarding support on the app for self help groups. Agents can pay on behalf of SHGs.'
    */ }
    },
   
    {
        title: 'Mobile & Web Application Development',
        icon: <FaMobileAlt size={48} style={{ color: '#1976d2' }} />, // blue
        desc: 'Custom mobile and web apps tailored to your business needs.'
    },
    {
        title: 'API Integration & Consulting',
        icon: <FaPlug size={48} style={{ color: '#ff9800' }} />, // orange
        desc: 'Seamless integration of APIs and expert consulting for digital transformation.'
    },
    {
        title: 'Custom Software Solutions',
        icon: <FaCogs size={48} style={{ color: '#6d4c41' }} />, // brown
        desc: 'Bespoke software solutions to solve unique business challenges.'
    }
    /* {
        title: 'Technical Support & Maintenance',
        icon: <FaTools size={48} style={{ color: '#e53935' }} />, // red
        desc: 'Reliable technical support and maintenance for your digital assets.',
        pricing: {
            visiting: 1000,
            details: 'Visiting Fee: ₹1000 per visit. For on-site technical support and maintenance. Additional fees may be applicable based on complexity.'
        }
    } */
];

const Pricing = () => (
    <div className="container py-5">
        <h2 className="mb-4 text-center">Our Service Pricing</h2>
        <div className="text-center mb-4" style={{ fontSize: '1em', color: '#666' }}>
            <strong>Note:</strong> All prices are in Indian Rupees (INR).
        </div>
        <div className="row g-4 justify-content-center">
            {/* Show only cards with pricing first */}
            {services.filter(service => service.pricing).map((service, idx) => (
                <div className="col-12 col-md-6 col-lg-4" key={service.title}>
                    <div className="card h-100 shadow-sm text-center border-success">
                        <div className="card-body d-flex flex-column align-items-center justify-content-center">
                            <div className="mb-3">{service.icon}</div>
                            <h5 className="card-title">{service.title}</h5>
                            <p className="card-text">{service.desc}</p>
                            {service.title === 'BG Mitra' && service.pricing ? (
                                <>
                                    <div className="d-flex justify-content-center align-items-center mb-3">
                                        <span className="badge bg-success fs-5 me-2">₹{service.pricing.monthly}/month</span>
                                        <span className="fs-5">or</span>
                                        <span className="badge bg-success fs-5 ms-2">₹{service.pricing.yearly}/year</span>
                                    </div>
                                    <p className="card-text" style={{ fontSize: '0.95em' }}>{service.pricing.details}</p>
                                </>
                            ) : service.pricing && service.pricing.standard ? (
                                <div className="mt-3">
                                    <span className="badge bg-info">Standard Report: ₹{service.pricing.standard}</span>
                                    <div className="mt-2" style={{ fontSize: '0.95em' }}>{service.pricing.details}</div>
                                </div>
                            ) : service.pricing && service.pricing.visiting ? (
                                <div className="mt-3">
                                    <span className="badge bg-info">Visiting Fee: ₹{service.pricing.visiting}</span>
                                    <div className="mt-2" style={{ fontSize: '0.95em' }}>{service.pricing.details}</div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            ))}
        </div>
        {/* Show Contact Us for price cards below */}
        <div className="row g-4 justify-content-center mt-2">
            {services.filter(service => !service.pricing).map((service, idx) => (
                <div className="col-12 col-md-6 col-lg-4" key={service.title}>
                    <div className="card h-100 shadow-sm text-center border-secondary">
                        <div className="card-body d-flex flex-column align-items-center justify-content-center">
                            <div className="mb-3">{service.icon}</div>
                            <h5 className="card-title">{service.title}</h5>
                            <p className="card-text">{service.desc}</p>
                            <div className="mt-3">
                                <span className="badge bg-primary text-light">Contact us </span>
                                {/*   <div className="mt-2">
                                    <a href="/contactus" className="btn btn-outline-primary btn-sm">Contact Us</a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default Pricing;
